import { ButtonRowCardFooter } from '@framework/ui';
import React from 'react';
import { down } from 'styled-breakpoints';
import styled from 'styled-components';

const CardFooterButtonsWrapper = styled.div`
  margin: 0 24px;
  ${down('sm')} {
    margin: 0 12px;
  }
`;

export interface ICardFooterButtonsProps {
  children?: React.ReactNode;
}

export function CardFooterButtons(props: ICardFooterButtonsProps) {
  return (
    <CardFooterButtonsWrapper>
      <ButtonRowCardFooter paddingSide={0}>
        {props.children}
      </ButtonRowCardFooter>
    </CardFooterButtonsWrapper>
  );
}
